import React from 'react'
import bgImage from "../../assets/images/bgImage1.jpg";
import { Card, Col, Container, Row } from 'reactstrap';
import ReviewTable from './ReviewTable';
import Header from 'components/VerticalLayout/Header';
import { useLocation } from 'react-router-dom';


const ComparableReviewPage = () => {

  document.title = "Title Apprasier | Review"

  const location = useLocation();
  const orderId = location.state?.orderId;

  return (
    <div className='account-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"hidden",
            paddingLeft:"8px"
            }}
        >
          <Container fluid>
            <Row>
              <Col>
                  <Card style={{backdropFilter:"blur(10px)",opacity:"1"}}>
                    <ReviewTable orderId={orderId}/>
                  </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
  )
}

export default ComparableReviewPage